module.exports = __webpack_public_path__ + "img/logo.e7b2b928.png";